// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"theme_breadcrumbs__kMoSj","active":"theme_active__cM7u5"};